export class CreateGrupoAdicionais {
  /**
   * @type {number}
   */
  IdEmpresa;

  /**
   * @type {string}
   */
  IdGrupo;

  /**
   * @type {string}
   */
  IdGrupoSelecao;

  /**
   * @type {boolean}
   */
  Ativo;

  /**
   * @param {CreateGrupoAdicionais} createGrupoAdicionais
   */
  constructor(createGrupoAdicionais) {
    if (createGrupoAdicionais) {
      this.IdEmpresa = createGrupoAdicionais.IdEmpresa;
      this.IdGrupo = createGrupoAdicionais.IdGrupo;
      this.IdGrupoSelecao = createGrupoAdicionais.IdGrupoSelecao;
      this.Ativo = createGrupoAdicionais.Ativo;
    }
  }
}

export class GrupoAdicionais {
  /**
   * @type {string}
   */
  Id;

  /**
   * @type {number}
   */
  IdEmpresa;

  /**
   * @type {string}
   */
  IdGrupo;

  /**
   * @type {string}
   */
  IdGrupoSelecao;

  /**
   * @type {boolean}
   */
  Ativo;

  /**
   * @type {Date}
   */
  CreatedAt;

  /**
   * @type {Date}
   */
  UpdatedAt;

  /**
   * @param {GrupoAdicionais} grupoAdicionais
   */
  constructor(grupoAdicionais) {
    if (grupoAdicionais) {
      this.Id = grupoAdicionais.Id;
      this.IdEmpresa = grupoAdicionais.IdEmpresa;
      this.IdGrupo = grupoAdicionais.IdGrupo;
      this.IdGrupoSelecao = grupoAdicionais.IdGrupoSelecao;
      this.Ativo = grupoAdicionais.Ativo;
      this.CreatedAt = grupoAdicionais.CreatedAt;
      this.UpdatedAt = grupoAdicionais.UpdatedAt;
    }
  }
}
